// IframeModal.jsx
import React from 'react';
import { Modal, Button } from 'react-bootstrap';

export default function IframeModal({ show, onHide, src, title = 'Occurrence' }) {
    return (
        <Modal show={show} onHide={onHide} centered backdrop="static" className="occurrence-modal">
            <Modal.Header closeButton closeVariant="white">
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ padding: 0 }}>
                <iframe
                    src={src}
                    title={title}
                    style={{ width: '100%', height: '80vh', border: 'none' }}
                />
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>Close</Button>
            </Modal.Footer>
        </Modal>
    );
}
